import { ListingInsightsTabId } from '@/models/listingInsightsTabIds';

const TAB_ID_TO_TRACKING_SLUG: Record<ListingInsightsTabId, string> = {
  [ListingInsightsTabId.Actions]: 'actions',
  [ListingInsightsTabId.Performance]: 'performance',
  [ListingInsightsTabId.Price]: 'price',
  [ListingInsightsTabId.ListingHistory]: 'listing_history',
  [ListingInsightsTabId.SimilarListings]: 'similar_listings',
  [ListingInsightsTabId.Leads]: 'leads',
  [ListingInsightsTabId.Ranking]: 'ranking',
};

/**
 * Maps a ListingInsights tab ID to the slug used in GTM tracking labels.
 * @param tabId - The tab ID to map.
 * @returns The slug used in GTM tracking labels.
 */
export function mapListingInsightsTabIdToTrackingSlug(tabId: ListingInsightsTabId): string {
  return TAB_ID_TO_TRACKING_SLUG[tabId];
}

export function buildTabNavigationLabel(fromTabSlug: string, toTabSlug: string): string {
  return `from_${fromTabSlug}_to_${toTabSlug}`;
}
